/**
 * Edit-only workflow URLs use `/site/:siteId/edit-only/:editOnlySiteId`.
 * `SitesEditOnly` list/API rows store the edit-only primary key on `id` and the parent site on `siteId`.
 */
export function resolveEditOnlyRouteIds(siteOrRow = {}) {
  const historyId = siteOrRow.historyId ?? siteOrRow.sitehistoryId ?? null

  if (siteOrRow.reassessmentFlag && historyId) {
    const siteId = siteOrRow.siteId || siteOrRow.SiteId || siteOrRow.Site?.id || siteOrRow.id
    return { siteId, editOnlySiteId: historyId }
  }

  const parentSiteId = siteOrRow.siteId || siteOrRow.SiteId
  const editOnlySiteId = siteOrRow.id

  if (parentSiteId && editOnlySiteId && parentSiteId !== editOnlySiteId) {
    return { siteId: parentSiteId, editOnlySiteId }
  }

  return {
    siteId: parentSiteId || editOnlySiteId,
    editOnlySiteId: historyId || editOnlySiteId
  }
}
